import { splitEncoding } from '@contentful/live-preview';
import { RenderNode } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

import { TextEffectCF } from '@/types';

import { textEffectColorMap } from '.';

export const renderAllTextAsSpans: RenderNode = {
  [BLOCKS.HEADING_1]: (_, children) => <span>{children}</span>,
  [BLOCKS.HEADING_2]: (_, children) => <span>{children}</span>,
  [BLOCKS.HEADING_3]: (_, children) => <span>{children}</span>,
  [BLOCKS.HEADING_4]: (_, children) => <span>{children}</span>,
  [BLOCKS.HEADING_5]: (_, children) => <span>{children}</span>,
  [BLOCKS.HEADING_6]: (_, children) => <span>{children}</span>,
  [BLOCKS.PARAGRAPH]: (_, children) => <span>{children}</span>,
};

export const getHexValues = (colors: TextEffectCF['fields']['colors']) => {
  return (colors || []).map((value) => {
    const colorKey = splitEncoding(value).cleaned as NonNullable<
      TextEffectCF['fields']['colors']
    >[number];

    return textEffectColorMap[colorKey];
  });
};
